import makeApiCall from "../master/axiosIndex";

const paymentsApis = {
  listPayment: (params: any) =>
    makeApiCall({
      url: "/ra-bill/payments/list",
      method: "get",
      params,
    }),
  paymentById: (paymentId: any) =>
    makeApiCall({
      url: `/ra-bill/payments/id/${paymentId}`,
      method: "get",
    }),
  approvalAction: (data: any) =>
    makeApiCall({
      url: "/ra-bill/payment/approval-action",
      method: "post",
      data,
    }),
};

export default paymentsApis;
